import React from "react";

import "../styles.scss";
import "../scripts";

import {
  primaryBlock,
  PrimaryBlockConfig,
  KameleonElement,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  renderSecondaryBlock,
  renderTertiaryBlock,
  getDefaultProps,
} from "@kameleon-core/lib";
import { Variants } from "@kameleon-util/global-theme";
import { Box, StylePropertyValue } from "theme-ui";

import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { layoutOptions, MediaCollectionType } from "./types/prop-types";

/** MediaCollection Primary */
const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.ExtraSmall,
  tertiaryBlockSize: TertiaryBlockSize.Default,
  blockTheme: BlockTheme.light,
};

export const MediaCollection = primaryBlock<MediaCollectionType>(
  blockConfig,
  ({
    SecondaryBlock,
    TertiaryBlock,
    title,
    logos,
    layoutProps,
  }: MediaCollectionType) => (
    <Box className="primary-media-collection-flex-wrap-small-media-v1 section_logo1 padding-global container-large">
      <Box className="padding-section-medium">
        {title && (
          <Box className="margin-bottom margin-medium text-align-center">
            <Box
              sx={{
                textAlign: layoutProps.alignment as StylePropertyValue<any>,
              }}
              className="max-width-large align-center"
            >
              <Variants.Heading as="h2" variant="h6">
                {title}
              </Variants.Heading>
            </Box>
          </Box>
        )}
        <Box
          sx={{
            justifyContent: layoutProps.alignment as StylePropertyValue<any>,
          }}
          className="logo1_component"
        >
          {logos?.map((logo, index) => (
            <Variants.BoxGrey
              variant={`${
                !layoutProps.itemBackground ? "" : "boxes.backgrounds.grey"
              }`}
              key={index}
              className={`${
                layoutProps.alignment === "left" && !layoutProps.itemBackground
                  ? "padding_left_off"
                  : "padding_left_on"
              } logo1_wrapper`}
            >
              <Variants.ImageNoRadius
                src={logo.url}
                loading="lazy"
                alt={logo.alt}
                className="logo1_logo"
              />
            </Variants.BoxGrey>
          ))}
        </Box>
        <Box
          sx={{ textAlign: layoutProps.alignment as StylePropertyValue<any> }}
          className="max-width-large align-center"
        >
          {renderSecondaryBlock(SecondaryBlock)}
          {renderTertiaryBlock(TertiaryBlock)}
        </Box>
      </Box>
    </Box>
  )
);

MediaCollection.defaultProps = getDefaultProps<MediaCollectionType>(defaults);

export const Element: KameleonElement = {
  component: MediaCollection,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
